export default __webpack_public_path__ + "static/char-08-5434679acc55372dd40d52bbfd97ab0e.gif";